import Page from "components/Page";
import React, { useEffect, useState } from "react";
import styles from "./ManageAISettings.module.scss";
import { withTranslation } from "react-i18next";
import Text from "components/Text";
import Card from "components/Card";
import { decodeId, encodeId } from "utils";
import toast from "react-hot-toast";
import ToggleSwitch from "components/ToggleSwitch";
import ManageAISettingsForm from "./components/ManageAISettingsForm";
import { updateOwnerAiSettings } from "repositories/ai-assistant-repository";
import Loader from "components/Loader";
import { useUser } from "repositories/user-repository";
import useHandleApiError from "hooks/useHandleApiError";

function ManageAISettings({ history, match, t }) {
  const accountOwnerId = decodeId(match.params.accountOwnerId);
  const {
    isLoading,
    data: apiRes,
    isFetching,
    error,
  } = useUser(accountOwnerId);
  const {
    aiTokens = 0,
    aiTokensUsed = 0,
    isAiSettingsEnabled = false,
  } = apiRes?.data || {};

  const [toggleOn, setToggleOn] = useState(!!isAiSettingsEnabled);
  const [showLoader, setShowLoader] = useState(false);
  useHandleApiError(isLoading, isFetching, error);

  useEffect(() => {
    if (typeof isAiSettingsEnabled === "boolean") {
      setToggleOn(isAiSettingsEnabled);
    }
  }, [isAiSettingsEnabled]);

  const goBack = () =>
    history.push(`/account-owner/${encodeId(accountOwnerId)}`);

  const handleToggle = async () => {
    const newToggleState = !toggleOn;
    setToggleOn(newToggleState);

    if (!newToggleState) {
      setShowLoader(true);
      try {
        const _data = {
          IsAiSettingsEnabled: newToggleState,
          Tokens: aiTokens || 0,
          OwnerId: +accountOwnerId,
        };
        const resp = await updateOwnerAiSettings(_data);
        toast.success(resp?.message);
      } catch (e) {
        toast.error(e.message);
      } finally {
        setShowLoader(false);
      }
    }
  };

  return (
    <>
      {(showLoader || isLoading) && <Loader />}
      <Page
        onBack={() => goBack()}
        className={styles["global-main-page"]}
        title={t("aiAssistant.manageAISettings.manageAISettings")}
      >
        <Text size="14px" weight="300" color="#000000" className="mb-4">
          {t("aiAssistant.aiAssistSubheading")}
        </Text>
        <div className={styles["new-instruction-messages"]}>
          <Card radius="10px" className={styles["instruction-card"]}>
            <div className={styles["toggle-wrapper"]}>
              <Text size="14px" marginBottom="0px" weight="600" color="#587e85">
                {t("aiAssistant.manageAISettings.enableAISettings")}
              </Text>
              <ToggleSwitch
                label="bill-me-later-toggle"
                value={!!toggleOn}
                onChange={handleToggle}
              />
            </div>
          </Card>
        </div>
        {toggleOn && (
          <ManageAISettingsForm
            aiTokens={aiTokens}
            aiTokensUsed={aiTokensUsed}
            isAiSettingsEnabled={toggleOn}
            accountOwnerId={accountOwnerId}
            goBack={goBack}
          />
        )}
      </Page>
    </>
  );
}

export default withTranslation()(ManageAISettings);
